import { mergeStates } from '../../iwProvider/StoreHelper';
import { LEAVE_DASHBOARD } from './Dashboard.actions';
import { Action } from 'redux';

const initialState = {
    selectedInputAmount: 0,
    selectedSliderAmount: 0,
    loadingNewRepaymentSchedule: false,
    chooseAmountReady: false,
    chooseAmountConfirmLoading: false
};

// eslint-disable-next-line import/no-default-export
export default function (state = mergeStates(initialState), action: Action) {
    switch (action.type) {
        case LEAVE_DASHBOARD:
            return mergeStates(initialState);

        default:
            return state;
    }
}
